import styled from 'styled-components';

import bg_desktop from '@assets/images/home/banner_bg.png';

export const Wrapper = styled.div`
	position: relative;
	background-repeat: no-repeat;
	background-size: cover;
	background-image: url('${bg_desktop}');

	@media (max-width: 1100px) {
		background: none;
	}
`;

export const Section = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;

	@media (max-width: 992px) {
		flex-direction: column;
	}
`;

export const BannerPic = styled.img`
	display: block;
	height: 100%;
	object-fit: cover;
	margin: 0 auto;
	max-width: 670px;
	width: 100%;

	@media (max-width: 992px) {
		max-width: 336px;
	}
`;

export const Group = styled.div`
	max-width: 680px;
	display: flex;
	flex-direction: column;
	align-items: baseline;
	gap: 10px;

	@media (max-width: 1442px) {
		margin-top: 40px;
	}

	@media (max-width: 992px) {
		width: 100%;
		justify-content: center;
		align-items: center;
	}
`;

export const Title = styled.h1`
	font-size: 32px;
	color: ${({ theme }) => theme.colors.text.title};

	span {
		color: ${({ theme }) => theme.colors.control.primary};
	}

	@media (max-width: 1442px) {
		font-size: 48px;
		letter-spacing: -0.02em;
	}

	@media (max-width: 992px) {
		text-align: center;
		font-size: 30px;
		margin-top: 16px;
	}
`;

export const Promo = styled.h3`
	font-size: 24px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.title};
	line-height: 1.2em;
	width: 90%;

	span {
		color: ${({ theme }) => theme.colors.control.primary};
	}

	@media (max-width: 992px) {
		text-align: center;
		font-size: 18px;
	}
`;

export const BannerPicWrapper = styled.div`
	margin-top: 30px;
	display: flex;
	justify-content: flex-end;

	@media (max-width: 992px) {
		width: 100%;
	}
`;

export const Trophy = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;

	@media (max-width: 992px) {
		flex-direction: column;
	}
`;

export const TrophyImage = styled.img`
	width: 60px;
	min-width: 60px;
`;

export const TrophyTextWrapper = styled.div`
	display: flex;
	flex-direction: column;

	@media (max-width: 992px) {
		text-align: center;
	}
`;

export const TrophyText = styled.div`
	color: ${({ theme }) => theme.colors.text.title};
	font-weight: 500;
	font-size: 20px;

	@media (max-width: 992px) {
		font-size: 18px;
	}
`;
